import React from "react";
import ProjectCard from "./ProjectCard";
import { projects } from "./data/projects";

export default function Projects() {
  return (
    <section id="projects" className="py-5 bg-light">
      <div className="container">
        <h2 className="text-center mb-4">My Projects</h2>
        <div className="row">
          {projects.map((project, i) => (
            <div className="col-md-6 col-lg-4 mb-4" key={i}>
              <ProjectCard project={project} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
